import Car from './car'

export default class Car20 extends Car {
  calculateAmount() {
    return 0.2 * this.fields.distance.value
  }
}
